export const LOGO_URL = "https://customer-assets-0z36b82j.emergentagent.net/job_krvmart-preview/artifacts/h1cla0s5_logo_krvmart-removebg-preview.png";

export default function Logo({ className = "h-9" }) {
  return <img src={LOGO_URL} alt="KRVMart — Everything for Everyday Living" className={className} />;
}
